<template>
  <div>
    <Wp_nav_bar title="京东.官方活动"/>
    <van-tabs v-model="active" @click="onClick">
      <van-tab title="热门会场" name="1"/>
      <van-tab title="热门榜单" name="2"/>
    </van-tabs>
    <UnionList
        :list-url="listUrl"
    ></UnionList>
  </div>
</template>
<script>
import UnionList from '../list/UnionList'
import common from '../../js/common'
import Wp_nav_bar from '../custom/Wp_nav_bar'

export default {
  components: { Wp_nav_bar, UnionList },
  data () {
    return {
      active: '1',
      listUrl: ''
    }
  },
  mounted () {
    let _active = this.$common.getUrlKey('active')
    if (_active) {
      this.active = _active
    }
    this.getListUrl()
  },
  methods: {
    getListUrl () {
      let url = common.get_activity_list
      this.listUrl = url.replace('[poolId]', this.active)
      this.listUrl = this.$union_utils.handleUbb(this.listUrl)
      console.log('getListUrl:' + this.listUrl)
      return this.listUrl
    },
    onClick (name, title) {
      console.log(name + '  ' + this.active)
      this.getListUrl()
    }
  }
}
</script>